import { ICrmeLeadContatoCleanDTO, ICrmeLeadContatoDTO, ICrmeLeadContatoFullDTO } from '../models/happy-code-api.model';
import { baseCreate } from './base/base-create.service';
import { baseFindList } from './base/base-find-list.service';
import { baseUpdate } from './base/base-update.service';

export const useLeadContatoCampanhaService = () => {
	const resourceURL = 'crme/lead-contato';

	return {
		...baseFindList<ICrmeLeadContatoCleanDTO, ICrmeLeadContatoDTO, ICrmeLeadContatoFullDTO>(resourceURL),
		...baseCreate<ICrmeLeadContatoCleanDTO, ICrmeLeadContatoDTO, ICrmeLeadContatoFullDTO>(resourceURL),
		...baseUpdate<ICrmeLeadContatoCleanDTO, ICrmeLeadContatoDTO, ICrmeLeadContatoFullDTO>(resourceURL),
	};
};
